<template>
  <div class="left_block my-notifications">
    <p class="header">Уведомления</p>

    <RequestsFilter @delete-all="deleteAll" :rows="rows" :search="search" @delete="deleteChecked" />

    <RequestsList
      @delete="deleteRequest"
      @changePage="changePage"
      :rows="rows"
      :is-loading="isLoading"
      :requests-list="requestsList"
      :total="requestsListTotal"
    />
  </div>
</template>

<script>
import RequestsFilter from '@/components/admin/my-requests/RequestsFilter'
import RequestsList from '@/components/admin/my-requests/RequestsList'
// import { toastInfo } from '@/lib/toastCfg'

export default {
  components: {
    RequestsFilter,
    RequestsList
  },
  data() {
    return {
      isLoading: true,
      rows: {
        checked: []
      },
      search: {
        text: '',
        page: 1
      }
    }
  },
  computed: {
    requestsList() {
      return this.$store.state.notifications.requestsList
    },
    requestsListTotal() {
      return this.$store.state.notifications.requestsListTotal
    }
  },
  methods: {
    loadData() {
      this.$axios
        .get('submit-applications?page=' + this.search.page)
        .then((resp) => {
          this.$store.commit('setRequestsList', { list: resp.data.data.data, total: resp.data.data.total })
        })
        .catch(this.$errorToast)
        .finally(() => {
          this.isLoading = false
        })
    },
    changePage(val) {
      this.search.page = val
      this.loadData()
    },
    deleteRequest(not) {
      alert(not.id)
      // this.$axios2
      //   .post('notifications', { notifications: [not.id] })
      //   .then(() => {
      //     this.$buefy.toast.open(toastInfo())
      //     this.loadData()
      //   })
      //   .catch(this.$errorToast)
    },
    deleteChecked() {
      // let data = []
      // this.rows.checked.forEach(not => {
      //   data.push(not.id)
      // })
      // this.$axios2
      //   .post('notifications', { notifications: data })
      //   .then(() => {
      //     this.$buefy.toast.open(toastInfo())
      //     this.rows.checked = []
      //     this.loadData()
      //   })
      //   .catch(this.$errorToast)
    },
    deleteAll() {
      // this.$axios2
      //   .post('notifications', { notifications: [] })
      //   .then(() => {
      //     this.$buefy.toast.open(toastInfo())
      //     this.loadData()
      //   })
      //   .catch(this.$errorToast)
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>
